module.exports = __webpack_public_path__ + "img/16m003-15.a265c071.jpg";